export default {
    data: () => ({
        translations: {
            title: {
                el: "Φορολογικά",
                en: "Tax Info",
                it: "Informazioni Fiscali"
            },
            description: {
                el: "Επεξεργαστείτε το ΑΦΜ, το ποσοστό ΦΠΑ και το Elorus client id της εταιρείας.",
                en: 'Edit the TIN, VAT percentage and Elorus client id of the company.',
                it: "Modificare il TIN, l'aliquota IVA e l'ID cliente Elorus dell'azienda."
            },
            vat: {
                el: "ΑΦΜ",
                en: "TIN",
                it: "TIN"
            },
            vatPercentage: {
                el: "Ποσοστό ΦΠΑ (%)",
                en: "VAT (%)",
                it: "IVA (%)"
            },
            errorMessage: {
                el: "Τόσο το TIN όσο και το Elurus Client Id είναι άκυρα",
                en: "Both TIN and Elurus Client Id are invalid",
                it: "Sia il TIN che l'ID cliente Elurus non sono validi."
            },
            successMessageTin: {
                el: "Το ΑΦΜ ενημερώθηκε με επιτυχία.",
                en: "TIN was updated successfully.",
                it: "Il TIN è stato aggiornato con successo."
            },
            successMessageVatPercentage: {
                el: "Το ποσοστό ΦΠΑ ενημερώθηκε με επιτυχία.",
                en: "VAT percentage was updated successfully.",
                it: "L'aliquota IVA è stata aggiornata con successo."
            },
            successMessageElorus: {
                el: "Το Elurus Client ενημερώθηκε με επιτυχία.",
                en: "Elurus Client was updated successfully.",
                it: "Il client Elurus è stato aggiornato con successo."
            },
            successMessageTinElorus: {
                el: "Τόσο το TIN όσο και το Elurus Client ενημερώθηκαν με επιτυχία",
                en: "Both TIN and Elurus Client were updated successfully",
                it: "Sia il TIN che il client Elurus sono stati aggiornati con successo."
            },
            successMessageTinVatPercentage: {
                el: "Το ΑΦΜ και το ποσοστό ΦΠΑ ενημερώθηκαν με επιτυχία.",
                en: "TIN and VAT percentage were updated successfully.",
                it: "TIN e aliquota IVA sono stati aggiornati con successo."
            },
            successMessageVatPercentageElorus: {
                el: "Το ποσοστό ΦΠΑ και το Elurus Client ενημερώθηκαν με επιτυχία.",
                en: "VAT percentage and Elurus Client were updated successfully.",
                it: "Aliquota IVA e client Elurus sono stati aggiornati con successo."
            },
            successMessageTinVatPercentageElorus: {
                el: "Το ΑΦΜ, το ποσοστό ΦΠΑ και το Elurus Client ενημερώθηκαν με επιτυχία.",
                en: "TIN, VAT percentage and Elurus Client were updated successfully.",
                it: "TIN, aliquota IVA e client Elurus sono stati aggiornati con successo."
            },
            errorTinRequired: {
                el: "Απαιτείται Αριθμός ΑΦΜ",
                en: "Vat Number is required",
                it: "È richiesto il numero di partita IVA"
            },
            errorTinLength: {
                el: "Ο Αριθμός ΑΦΜ πρέπει να έχει 9 με 12 χαρακτήρες",
                en: "Vat Number must be 9 to 12 characters long",
                it: "Il numero di partita IVA deve essere lungo 9 a 12 caratteri"
            },
            errorVatPercentageRequired: {
                el: "Απαιτείται ποσοστό ΦΠΑ",
                en: "VAT percentage is required",
                it: "L'aliquota IVA è richiesta"
            },
            errorVatPercentageRange: {
                el: "Το ποσοστό ΦΠΑ πρέπει να είναι μεταξύ 0 και 100",
                en: "VAT percentage must be between 0 and 100",
                it: "L'aliquota IVA deve essere tra 0 e 100"
            },
        }
    })
};
